import React from 'react';
import './Row.scss';
import { useDataLayerValue } from '../../../DataLayer';

function HeaderTable(props) {
    const [{ lang }] = useDataLayerValue();
    return (
        <div className="playlist-table--row playlist-table--row--header">
            <div className="column-1">
                #
            </div>
            <div className="column-2">
                {lang === 'en' ? 'TITLE' : 'TÊN BÀI HÁT'}
            </div>
            <div className="column-3">
                {lang === 'en' ? 'VIEW' : 'LƯỢT NGHE'}
            </div>
            <div className="column-4">
                <svg width="1.2em" height="1.2em" viewBox="0 0 16 16" className="bi bi-clock" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm8-7A8 8 0 1 1 0 8a8 8 0 0 1 16 0z"></path><path d="M7.5 3a.5.5 0 0 1 .5.5v5.21l3.248 1.856a.5.5 0 0 1-.496.868l-3.5-2A.5.5 0 0 1 7 9V3.5a.5.5 0 0 1 .5-.5z"></path></svg>
            </div>
        </div>
    );
}

export default HeaderTable;